// src/Views/siteData.js — Source-of-truth content for the long-scroll site.

export const ROTATE_WORDS = [
  'systems',
  'products',
  'tools',
  'companies',
  'experiences',
];

export const BUILD_SECTIONS = [
  {
    label: 'Shipped & Live',
    sublabel: 'Three systems you can use right now.',
    builds: [
      {
        title: 'Master Your Shot',
        status: 'Shipped',
        domain: 'Youth Sports Coaching',
        description:
          'Coaching platform for Bat City Archery, a nationally ranked youth archery program. Playbook systems, training analytics, and a hold-analysis lab built from real coaching problems.',
        link: 'https://masteryourshot.com',
        accent: 'cyan',
      },
      {
        title: 'Gears of Destiny',
        status: 'Shipped',
        domain: 'Board Game Design',
        description:
          'A cooperative tabletop adventure where the board is a shifting mechanical puzzle. Counter-rotating rings, spinning platform rooms, and doors that open and close with timing.',
        link: 'https://gears-of-destiny.vercel.app',
        accent: 'magenta',
      },
      {
        title: 'Moonlists',
        status: 'Shipped',
        domain: 'Cognitive Observatory',
        description:
          'AI-powered analysis of reflective journaling. Monthly cognitive insights, progression tracking across thinking patterns, and visualization of mental and narrative dynamics over time.',
        link: 'https://moonlist-demo.vercel.app',
        accent: 'purple',
      },
    ],
  },
  {
    label: 'Active Client Work',
    sublabel: 'Paid engagements currently in flight.',
    builds: [
      {
        title: 'GameSignals',
        status: 'Active',
        domain: 'Games Industry Intelligence',
        description:
          'Games industry OSINT — change drivers, forecast ledgers, signal schemas, and source credibility scoring. Active private client engagement; details on request.',
        accent: 'cyan',
      },
    ],
  },
  {
    label: 'In Progress',
    sublabel: 'Systems currently in development.',
    builds: [
      {
        title: 'Dominion Storyteller',
        status: 'In Progress',
        domain: 'Narrative AI',
        description:
          'An AI-powered system that narrates and illustrates Dominion gameplay through generated stories and visuals, personalized to player decisions and tone.',
        link: '/dominion-project',
        accent: 'magenta',
      },
      {
        title: 'OceansThink',
        status: 'In Progress',
        domain: 'AI Motion Graphics',
        description:
          'An AI motion graphics generator that turns natural language prompts into Remotion code, with a modular skills system for domain-specific animation knowledge.',
        accent: 'purple',
      },
    ],
  },
];

export const RECOGNITIONS = [
  { title: 'Finalist', detail: 'World Wide Vibes Hackathon, GenAI Academy (March 2026)' },
  { title: 'Honorable Mention', detail: 'Montgomery Safety Lens — civic tech competition' },
];

export const STATS = [
  { num: '06', label: 'Domains' },
  { num: '03', label: 'Shipped & Live' },
  { num: '02', label: 'Active Engagements' },
  { num: '00', label: 'Lines of code I write' },
];

export const ENGAGEMENT_GROUPS = [
  {
    label: 'Project-Based',
    sublabel: 'Fixed scope · milestone-paid',
    accent: 'var(--magenta)',
    items: [
      {
        name: 'Discovery & Systems Mapping',
        note: 'Problem decomposition, system design, and a buildable spec.',
        price: '$7K – $10K',
      },
      {
        name: 'Build & Iteration Engagement',
        note: 'Full build with a defined iteration loop. Production-ready deliverable.',
        price: '$10K – $20K',
      },
    ],
  },
  {
    label: 'Retainer',
    sublabel: 'Ongoing',
    accent: 'var(--purple)',
    items: [
      {
        name: 'Advisor Retainer',
        note: 'Strategic access, limited hours, async-first. For ongoing counsel, not execution.',
        price: '$3K – $5K / mo',
      },
      {
        name: 'Embedded Build Partnership',
        note: 'Fractional build leadership. Currently servicing one such client.',
        price: '$32K – $40K / mo',
      },
    ],
  },
  {
    label: 'Hourly',
    sublabel: 'No active engagement',
    accent: 'var(--cyan)',
    items: [
      {
        name: 'Ad-hoc Consulting & Discovery',
        note: 'Cold-start calls, discrete questions.',
        price: '$300 – $500 / hr',
      },
      {
        name: 'Project Overage',
        note: 'Work beyond agreed scope inside an active engagement.',
        price: '$300 / hr',
      },
    ],
  },
];

export const ABOUT_TAGS = [
  'AUSTIN, TX',
  'COMPETITIVE INTEL',
  'GAMES INDUSTRY',
  'ARCHERY COACH',
  'DOMINION ENJOYER',
];
